import axios from "axios";

export const getBaseUrl = () => {
  const envUrl = process.env.REACT_APP_READER_API || "http://localhost:8000/api/v1";
  // Remove any trailing /reader or trailing slashes to guarantee clean routing
  return envUrl.replace(/\/reader\/?$/, "").replace(/\/+$/, "");
};

const API = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptors for automatically handling auth tokens
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token && token !== "undefined" && token !== "null") {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Error handling interceptor
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const errorCode = error.response?.data?.code || error.response?.data?.error_code;
    const message = error.response?.data?.message || "";

    // Invalidate session on 401 or deactivation/deletion
    if (
      status === 401 ||
      (status === 403 &&
        (errorCode === "ACCOUNT_DEACTIVATED" ||
          errorCode === "ACCOUNT_DELETED" ||
          message.toLowerCase().includes("deactivated") ||
          message.toLowerCase().includes("deleted")))
    ) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("authUser");
      if (typeof window !== "undefined") {
        window.dispatchEvent(new CustomEvent("haven_auth_unauthorized"));
        if (!window.location.pathname.includes("/login") && !window.location.pathname.includes("/signup")) {
          window.location.href = "/login";
        }
      }
    }

    console.error("API Error:", error);
    return Promise.reject(error);
  }
);

export default API;
